import React, { useState } from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ItemImageEdit({ imageUrl, item, setItem, setChangeImage }) {
  const [open, setOpen] = useState(false);
  const handleClose = (value) => {
    if (value) {
      setItem({ ...item, image_url: "" });
      setChangeImage(true);
    }
    setOpen(false);
  };
  return (
    <div>
      <div className="relative" style={{ width: "200px", height: "200px" }}>
        <img src={imageUrl} alt="" style={{ width: "100%", height: "100%" }} />
        <CancelIcon
          style={{
            position: "absolute",
            top: "-10px",
            right: "-10px",
            fontSize: "32px",
            cursor: "pointer",
          }}
          onClick={() => setOpen(!open)}
        />
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={(e) => setOpen(!open)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title"></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to Delete this ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)} color="primary">
            CANCEL
          </Button>
          <Button onClick={() => handleClose(true)} color="primary">
            YES
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ItemImageEdit;
